import { styled } from '@mui/material';
import { BaseCard, BaseCardLabel } from 'console/shared/styles/mixins/base-card';
export const RfIndicatorCard = styled(BaseCard)({
    display: 'flex',
    rowGap: '4px',
    flexDirection: 'column',
});
export const RfIndicatorCardLabel = styled(BaseCardLabel)({
    fontSize: '0.7em',
});
